import { Injectable, OnDestroy } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from '../auth.service';
import { Subject, takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements OnDestroy {  

  protected _onDestroy = new Subject();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Check if we're currently on the SSO login page (navigating away during auth)
    const currentUrl = this.router.url;
    const isComingFromSso = currentUrl.includes('/sso/login');
    
    if (this.authService.isAuthenticated) {
      // logged in so return true
      return true;
    }

    // If coming from SSO page, skip logout and allow navigation check to proceed
    // This prevents logout from being called during the SSO authentication flow
    if (isComingFromSso) {
      this.authService.setPreviousUrl(state.url);
      return false;
    }

    // not logged in so redirect to login page with the return url
    this.authService.logout().pipe(takeUntil(this._onDestroy)).subscribe();
    this.authService.setPreviousUrl(state.url);
    return false;
  }

  ngOnDestroy() {
    this._onDestroy.complete();
  }
}
